import React, { useState } from "react";
import { AiOutlineEye, AiOutlineEyeInvisible } from "react-icons/ai";
import formImage from "../../assets/login/cp-form-pic.svg";
import { useNavigate } from "react-router-dom";
import { useForm } from "react-hook-form";

const SignUp = () => {
  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);
  const navigate = useNavigate();

  //Initializing the react-hook-form
  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm();

  const redirectToSignInpage = () => {
    navigate("/auth/sign-in");
  };

  return (
    <div className="flex min-h-screen items-center justify-center  bg-gradient-to-tr from-purple-300 via-purple-600 to-purple-300 px-6  sm:px-20">
      <div className="flex  w-full  items-center justify-center gap-10 rounded-lg bg-white ">
        {/* Form Section */}
        <div className="w-full max-w-lg p-4 lg:w-1/2">
          <div className="mb-3 text-start">
            <h2 className="mb-4 text-3xl font-bold capitalize tracking-normal text-purple-600">
              Sign Up
            </h2>
          </div>
          <form className="grid grid-cols-1 gap-4 md:grid-cols-2 ">
            {/* Name */}
            <div className="col-span-2 flex flex-col gap-1">
              <label htmlFor="" className=" text-sm tracking-wide">
                Name <span className="text-red-500">*</span>
              </label>
              <input
                type="text"
                placeholder="Name"
                className="w-full rounded-md border border-gray-300 px-3 py-2 focus:outline-none focus:ring-2 focus:ring-purple-500"
                {...register("name", {
                  required: "Name is required",
                })}
              />
            </div>

            {/* Email */}
            <div className="flex flex-col gap-1">
              <label htmlFor="" className=" text-sm tracking-wide">
                Email <span className="text-red-500">*</span>
              </label>
              <input
                type="email"
                placeholder="Email"
                className="w-full rounded-md border border-gray-300 px-3 py-2 focus:outline-none focus:ring-2 focus:ring-purple-500"
                {...register("email", {
                  required: "email is required",
                })}
              />
            </div>

            {/* Phone No */}
            <div className="flex flex-col gap-1">
              <label htmlFor="" className=" text-sm tracking-wide">
                Phone <span className="text-red-500">*</span>
              </label>
              <input
                type="tel"
                placeholder="Phone number"
                maxLength={10}
                className="w-full rounded-md border border-gray-300 px-3 py-2 focus:outline-none focus:ring-2 focus:ring-purple-500"
                {...register("phone", {
                  required: "phone is required",
                })}
              />
            </div>

            {/* Date of Birth */}
            <div className="flex flex-col gap-1">
              <label htmlFor="" className=" text-sm tracking-wide">
                Date of Birth <span className="text-red-500">*</span>
              </label>
              <input
                type="date"
                placeholder="Birth date"
                className="w-full rounded-md border border-gray-300 px-3 py-2 focus:outline-none focus:ring-2 focus:ring-purple-500"
                {...register("dateOfBirth", {
                  required: "Date of Birth is required",
                })}
              />
            </div>

            {/* Gender */}
            <div className="flex flex-col gap-1">
              <label htmlFor="" className=" text-sm tracking-wide">
                Gender <span className="text-red-500">*</span>
              </label>
              <select
                className="w-full rounded-md border border-gray-300 px-3 py-2 focus:outline-none focus:ring-2 focus:ring-purple-500"
                {...register("gender", {
                  required: "Gender is required",
                })}
              >
                <option value="" disabled selected>
                  Select gender
                </option>
                <option value="Male">Male</option>
                <option value="Female">Female</option>
                <option value="Other">Other</option>
              </select>
            </div>

            {/* Address */}
            <div className="col-span-2 flex flex-col gap-1">
              <label htmlFor="" className=" text-sm tracking-wide">
                Address <span className="text-red-500">*</span>
              </label>
              <textarea
                placeholder="Address"
                className="h-[40px] w-full rounded-md border border-gray-300 px-3 py-2 focus:outline-none focus:ring-2 focus:ring-purple-500"
                required
              />
            </div>

            {/* Password */}
            <div className="relative col-span-2 flex flex-col gap-1">
              <label htmlFor="" className=" text-sm tracking-wide">
                Password <span className="text-red-500">*</span>
              </label>
              <input
                type={showPassword ? "text" : "password"}
                placeholder="Password"
                className="w-full rounded-md border border-gray-300 px-3 py-2 focus:outline-none focus:ring-2 focus:ring-purple-500"
                required
              />
              <button
                type="button"
                onClick={() => setShowPassword(!showPassword)}
                className="absolute right-3 top-1/2 -translate-y-1/2"
              >
                {showPassword ? (
                  <AiOutlineEyeInvisible className="h-4 w-4 text-gray-500" />
                ) : (
                  <AiOutlineEye className="h-4 w-4 text-gray-500" />
                )}
              </button>
            </div>
            {/* <div className="relative ">
              <input
                type={showConfirmPassword ? "text" : "password"}
                placeholder="Confirm password"
                className="w-full rounded-md border border-gray-300 px-3 py-2 focus:outline-none focus:ring-2 focus:ring-purple-500"
                required
              />
              <button
                type="button"
                onClick={() => setShowConfirmPassword(!showConfirmPassword)}
                className="absolute right-3 top-1/2 -translate-y-1/2"
              >
                {showConfirmPassword ? (
                  <AiOutlineEyeInvisible className="h-4 w-4 text-gray-500" />
                ) : (
                  <AiOutlineEye className="h-4 w-4 text-gray-500" />
                )}
              </button>
            </div> */}
            <button
              type="submit"
              className="w-full rounded-md bg-purple-600 px-4 py-2 font-semibold text-white transition-colors hover:bg-purple-700 sm:col-span-2"
            >
              Sign Up
            </button>
            <div className="text-md text-center text-gray-500 sm:col-span-2">
              Already have an account?{" "}
              <p
                className="text-purple-600 hover:underline"
                onClick={redirectToSignInpage}
              >
                Log In
              </p>
            </div>
          </form>
        </div>

        <div className="hidden w-1/2 items-center justify-center  lg:flex">
          <img
            src={formImage}
            alt="Sign up illustration"
            className="h-auto w-full object-contain p-6"
          />
        </div>
      </div>
    </div>
  );
};

export default SignUp;
